import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/hooks/useAuth';
import { ProjectProvider } from '@/hooks/useProjects';

function App() {
  return (
    <AuthProvider>
      <ProjectProvider>
        <div className="App">
          <Outlet />
        </div>
      </ProjectProvider>
    </AuthProvider>
  );
}

export default App;